import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { codeVergessen, gemerkterCode, rueckwegZiel } from "@/lib/webseite/rueckgewinnung";

/**
 * Rückgewinnung (Daniel 01.11.2026, Rückweg neu 02.11.2026): Wer auf /fuer-dich/<code> ohne Konto „Taler abholen“
 * antippt, sich anmeldet oder erst registriert, kommt einmal auf seine Seite zurück, die dann von selbst einlöst und die
 * Bestätigung zeigt. Der Browser merkt sich dafür den Code (höchstens 14 Tage).
 *
 * Gesprungen wird erst dort, wo Anmeldung und Bestätigungsmail landen (`rueckwegZiel()`: Startseite und
 * Mitgliederbereich, gewohnte wie neue Ansicht), nie schon auf /login oder /registrieren: Die leiten nach dem Anmelden
 * selbst weiter, und ein früher Sprung ließ die Anmeldeseite danach ohne `?redirect=` nach /mein-bereich schicken.
 * Liest nur den Speicher und die lokale Sitzung (kein Netzwerk); ohne Merker tut der Baustein nichts.
 */
export default function RueckgewinnungNachAnmeldung() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [angemeldet, setAngemeldet] = useState(false);

  useEffect(() => {
    let aus = false;
    if (gemerkterCode()) void supabase.auth.getSession().then(({ data }) => !aus && setAngemeldet(!!data.session?.user));
    const { data } = supabase.auth.onAuthStateChange((ereignis, sitzung) => {
      if (ereignis === "SIGNED_IN" || ereignis === "INITIAL_SESSION") setAngemeldet(!!sitzung?.user);
      if (ereignis === "SIGNED_OUT") setAngemeldet(false);
    });
    return () => {
      aus = true;
      data.subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!angemeldet) return;
    const ziel = rueckwegZiel(pathname, gemerkterCode());
    if (!ziel) return;
    codeVergessen();
    navigate(ziel, { replace: true });
  }, [angemeldet, pathname, navigate]);

  return null;
}
